import { Alert16, Check16 } from '@bphxd/ds-core-react/lib/icons';
import { Event } from '../../../graph-queries/__generated__/graphql';
import { FCC } from '../../../lib/types';
import { FormModal } from '../../molecules/FormModal/FormModal';
import { useReadinessCheck, getTargetKpi } from './ReadinessCheck.util';
import ReadinessCheckDetails from './ReadinessCheckDetails';
import { Spinner } from '@bphxd/ds-core-react';

const ReadinessCheck: FCC<{ event: Event }> = ({ event }) => {
  const readiness = useReadinessCheck(event);
  const { target, error: targetError } = getTargetKpi(event, 'BASELINE');

  return (
    <FormModal
      title={`Readiness Check: ${event.eventDescription} (${event.eventType})`}
      renderForm={() => <ReadinessCheckDetails event={event} />}
      renderButton={(onClick) =>
        targetError ? (
          <div /> // KPI target unavailable
        ) : readiness.loading ? (
          <Spinner size="sm" title="Loading readiness data" />
        ) : readiness.error ? (
          <Alert16 title="Readiness calculation error" />
        ) : readiness.readinessPerc >= target ? (
          <Check16 cursor={'pointer'} onClick={onClick} title="Click for more details" />
        ) : (
          <Alert16 cursor={'pointer'} onClick={onClick} title="Target not reached" />
        )
      }
      size="lg"
    />
  );
};

export default ReadinessCheck;
